import stateGo from 'redux-ui-router/lib/state-go';

export default function clearAllEvent(
  { dispatch },
  key,
  evt
) {
  evt.preventDefault();
  dispatch(stateGo('datacenter.main', { selectedRows: {} }));

  const event = new Event('clearAll');
  document.dispatchEvent(event);
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/refineColumns/children/events/clearAllEvent.js